import type { Page } from '../../types';

const performanceConversationQ3: Page[] = [
  {
    pageType: 'question',
    title: 'Quarter 3 (October to December) - Performance Conversation',
    name: 'performance-q3',
    hidePageTitle: true,
    description:
      "Jobholder and line manager should hold a quarterly conversation to discuss performance to date, providing evidence against the 'what' and 'how' from minimum standards and objectives set",
    questions: [
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Summary',
        hint: 'In your summary, clearly refer to each minimum standard and each business objective, and explain how they are met',
        name: 'performance-summary-q3',
        placeholder:
          'This summary will be reviewed by panel chair ahead of moderation - please provide a clear concise summary of performance against minimum standards and business objectives',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default performanceConversationQ3;
